import {
  useGetRegions,
  usePermissions,
  useUpsertRegion,
} from '@dispatch/shared/hooks';
import { Region } from '@dispatch/shared/types';
import { useCurrentUser } from '@dispatch/web/auth';
import { RegionsDetails, validateRegion } from '@dispatch/web/features/regions';
import {
  useNotification,
  useNotificationMutationFactory,
} from '@dispatch/web/ui';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

const RegionCreatePage = () => {
  const navigate = useNavigate();
  const [newRegionId, setNewRegionId] = React.useState<string | null>();

  const { notifyError } = useNotification();
  const { permissions } = usePermissions();
  const { tenantId } = useCurrentUser();
  const { data: allRegions, status } = useGetRegions({
    tenantId: tenantId || '',
  });
  const { notifySuccess } = useNotificationMutationFactory('Region', 'update');
  const onSuccess = () => {
    notifySuccess();
    navigate(`/admin/regions/${newRegionId}`);
  };

  const { upsertRegion, status: upsertStatus } = useUpsertRegion(
    tenantId || '',
    newRegionId || '',
    onSuccess
  );

  const handleSave = (value: Partial<Region>) => {
    value.id = uuidv4();
    setNewRegionId(value?.id);
    value.createdAt = new Date().toISOString();
    value.editedAt = new Date().toISOString();
    value.isActive = true;
    value.deactivatedAt = null;

    const hasValidationErrors = validateRegion(
      value,
      allRegions?.data || [],
      notifyError
    );

    if (!hasValidationErrors) {
      const updateRegions = [...(allRegions?.data || []), value];

      upsertRegion(updateRegions as Region[]);
    }
  };

  return (
    <RegionsDetails
      onSave={handleSave}
      status={upsertStatus === 'loading' ? upsertStatus : status}
      data={{} as Region}
      allRegions={allRegions?.data || []}
      permissions={permissions}
    />
  );
};

export default RegionCreatePage;
